/** Filters and sorts the global task list based on the active view (e.g., plan, organize) without modifying the source data. */
import { useMemo } from 'react';
import { getProcessedTasksForView } from '@/features/tasks/utils/views/listViewTasksUtils';

/**
 * A custom hook to filter and sort tasks based on the current view.
 * This ensures that the original `allTasks` array remains unmodified for crucial operations
 * like `orderKey` calculations, while allowing view-specific presentation.
 *
 * @param {Array<Object>} allTasks - The complete list of tasks from useTasksContext.
 * @param {string} view - The identifier for the current view (e.g., 'plan', 'organize').
 * @returns {Array<Object>} The processed list of tasks for the specified view.
 */
const useViewSpecificTasks = (allTasks, view) => {
  return useMemo(
    () => getProcessedTasksForView(allTasks, view),
    [allTasks, view],
  );
};

export default useViewSpecificTasks;
